import { selector } from 'recoil'

import { $apiClient } from '../core'

export const $microservices = selector({
  key: 'Microservices',
  get: async ({ get }) => {
    const client = get($apiClient)
    const res = await client.metadata.getMicroserviceList()
    return res.microservices
  },
})
